document.addEventListener("DOMContentLoaded", function () {
  function initAddToCart() {
    if (document.querySelector(".card-product")) {
      AddtoCartBtn();
    }
  }

  // Initial check
  initAddToCart();

  // Watch for new elements being added
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        if (document.querySelector(".card-product")) {
          AddtoCartBtn();
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});


function updateSelectedVariant(form) {
  const productCard = form.closest(".card-product");
  const variants = JSON.parse(productCard.dataset.variants);

  const selectedOptions = Array.from(
    form.querySelectorAll(".card-product-option-btn.active")
  ).map((btn) => btn.dataset.optionValue);

  const selectedVariant = variants.find((variant) => {
    const variantOptions = variant.options.filter(
      (o) => o && o !== "null" && o !== ""
    );
    const filteredSelected = selectedOptions.filter(
      (o) => o && o !== "null" && o !== ""
    );
    return (
      variantOptions.length === filteredSelected.length &&
      variantOptions.every((opt, i) => opt === filteredSelected[i])
    );
  });

  if (selectedVariant) {
    const hiddenInput = form.querySelector(".card-product-selected-id");
    if (hiddenInput) hiddenInput.value = selectedVariant.id;
  }
}

function handleFormSubmit(evt) {
  evt.preventDefault();

  const form = evt.target;
  const formData = new FormData(form);

  const submitBtn = form.querySelector(".card-product-add-btn");
  const originalText = submitBtn.innerHTML;

  submitBtn.innerHTML = "Adding...";
  submitBtn.disabled = true;

  const sideCart = document.querySelector("side-cart");
  if (sideCart) sideCart.classList.remove("loaded");

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status !== "bad_request") {
        if (sideCart) sideCart.addLineItem(data);
      } else {
        alert("Error: " + data.message);
      }
    })
    .catch((err) => {
      console.error("Error:", err);
      alert("Error adding item to cart");
    })
    .finally(() => {
      submitBtn.innerHTML = originalText;
      submitBtn.disabled = false;
    });
}

function AddtoCartBtn(){
  

  document.querySelectorAll(".card-product-option-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const form = btn.closest(".card-product-add-form");
      const optionName = btn.dataset.optionName;

      form.querySelectorAll(`[data-option-name="${optionName}"]`).forEach((b) =>
        b.classList.remove("active")
      );
      btn.classList.add("active");

      updateSelectedVariant(form);
    });
  });

  document.querySelectorAll(".card-product-add-form").forEach((form) => {
    form.addEventListener("submit", handleFormSubmit);

    form.querySelectorAll(".card-product-option-group").forEach((group) => {
      const firstBtn = group.querySelector(".card-product-option-btn");
      if (firstBtn && !firstBtn.classList.contains("active")) {
        firstBtn.classList.add("active");
      }
    });

    updateSelectedVariant(form);
  });
}